import Router from 'vue-router';
import routes from './routes';
import locale from '../lang/locale';

export default () => {
    let router =  new Router({
        routes,
        mode: 'history',
        base: `/${process.env.VUE_APP_TYPE}${process.env.VUE_APP_NAME}/${locale.base}`,
        linkExactActiveClass: 'exact-active',
        linkActiveClass: 'active',
        scrollBehavior(to, from, savedPosition) {
            if (savedPosition) {
                return savedPosition
            } else {
                return {
                    x: 0,
                    y: 0
                }
            }
        }
    })
    return router
}